export default "__VITE_ASSET__OwxojOJl__"